export const en = {
    "common.empty": "Empty",
    "common.in": "in",
    "common.actions.close": "Close",
    "common.actions.delete": "Delete",
    "common.actions.cancel": "Cancel",
    "common.actions.select": "Select",
    "common.actions.confirm-deletion": "Confirm deletion",
    "common.actions.try_again": "Try again",
    "common.actions.go_to": "Go to card",
    "common.actions.step_back": "Back",
    "common.actions.refresh": "Refresh",

    "wallet.auth.title": "Create an e-wallet account",
    "wallet.auth.register": "Register",
    "wallet.auth.login": "Login",
    "wallet.auth.already_have": "Already have an account?",

    "auth.register.title": "Registration",
    "auth.register.first_name": "First Name",
    "auth.register.last_name": "Last Name",
    "auth.register.email": "Email",
    "auth.register.address": "Address",
    "auth.register.city": "City",
    "auth.register.country": "Country",
    "auth.register.zip_code": "Zip Code",
    "auth.register.address_section": "Address Details",
    "auth.register.continue_btn": "Continue",
    "auth.register.enter_help": "Login for registered users.",
    "auth.register.enter_code_help": "Enter the code from the message",
    "auth.register.enter_code_descr": "Enter the 4-digit code sent to your number",
    "auth.register.send_again_btn": "Send again",
    "auth.register.set_pin.help": "Set your PIN code",
    "auth.register.set_pin.descr": "Create a 4-digit PIN code for transaction confirmation",
    "auth.register.set_pin.continue": "Continue",

    "wallet.auth.login.register_link": "Registration",
    "wallet.auth.login.login": "Login to your account",
    "wallet.auth.login.sms_help": "You will receive an SMS with a confirmation code to log into your account.",
    "wallet.auth.login.new_help": "Registration for new users.",
    "wallet.auth.login.send_code": "Send code",
    "wallet.auth.login.enter_code": "Enter the code from the message",
    "wallet.auth.login.enter_code_descr": "Enter the 4-digit code sent to your number",
    "wallet.auth.login.enter_btn": "Login",
    "wallet.auth.login.sms_repeat": "Send again",
    "wallet.auth.change_number": "Change number",

    "phone_input.phone": "Phone number",
    "phone_input.phone.default_country.name": "United Kingdom",
    "phone_input.phone.default_country.code": "+44",
    "phone_input.phone.default_country.iso": "GB",
    "phone_input.phone.default_country.flag": "https://cdn.kcak11.com/CountryFlags/countries/gb.svg",
    "phone_input.phone.default_country.mask": "#########",

    "menu.home": "Home",
    "menu.wallet": "Wallet",
    "menu.payment": "Payment",
    "menu.history": "History",
    "menu.cards": "Cards",
    "menu.settings": "Account",

    "notifications.title": "Notifications",
    "notifications.close_btn": "Close",

    "qr_payment.title": "Pay using QR code",
    "qr_payment.description": "Now you can transfer funds simply by pointing your camera at the QR code",

    "qr_payment.not_avaliable.title": "QR code payment is temporarily unavailable,",
    "qr_payment.not_avaliable.subtitle": "we apologize for any inconvenience caused.",
    "qr_payment.your_qr": "Your QR code",
    "qr_payment.scan_qr": "Scan",

    "payment.topup_btn": "Top up",
    "payment.exchange_btn": "Exchange",    
    "payment.withdrawal_btn": "Withdraw",
    "payment.topup.not_avaliable": "Withdrawals are unavailable, please complete identification.",
    "payment.withdrawal.not_avaliable": "Wallet top-up is unavailable, please complete identification.",
    "payment.send_btn": "Send",
    "payment.qr_file_upload": "Drag and drop or select QR-code file",
    "payment.qr_file_upload_extensions": "Allowed formats: png, jpg",

    "wallet_save.send_btn": "Send",

    "transactions.title": "Transactions",
    "transactions.last.title": "Last transactions",
    "transactions.list.operation": "Operation",
    "transactions.list.withdrawal": "Withdrawal",
    "transactions.list.topup": "Top-up",
    "transactions.list.exchange": "Exchange",
    "transactions.list.empty_descr": "Make your first payment, and your transactions will appear here",
    "transactions.list.status.complete": "Complete",
    "transactions.list.status.partial_complete": "Partially paid",
    "transactions.list.status.paid": "Paid",
    "transactions.list.status.failed": "Failed",
    "transactions.list.status.pending": "Pending",

    "transactions.list.details.title": "Transaction Info",
    "transactions.list.details.transaction": "Transaction",
    "transactions.list.details.transaction.id": "Transaction ID",
    "transactions.list.details.transaction.type": "Transaction type",
    "transactions.list.details.transaction.status": "Status",
    "transactions.list.details.transaction.date": "Timestamp",
    "transactions.list.details.transaction.wallet": "Wallet",
    "transactions.list.details.transaction.account": "Account (Wallet)",
    "transactions.list.details.transaction.currency": "Currency",
    "transactions.list.details.transaction.amount": "Amount",
    "transactions.list.details.transaction.commission": "Commission",
    "transactions.list.details.transaction.final_amount": "Total Credited/Debited",
    "transactions.list.details.method": "Payment Method",
    "transactions.list.details.method.network": "Network",
    "transactions.list.details.method.address": "Address",
    "transactions.list.details.method.confirmation": "Confirmation",
    "transactions.list.details.method.recipient_card": "Recipient Card",
    "transactions.list.details.method.bank": "Bank",
    "transactions.list.details.method.recipient": "Recipient",
    "transactions.list.details.method.iban_account_number": "IBAN / Account Number",
    "transactions.list.details.method.bic_swift": "BIC / SWIFT",
    "transactions.list.details.method.reference": "Payment Purpose",
    "transactions.list.details.method.provider": "Provider",
    "transactions.list.details.method.identifier": "Identifier",

    "account.create_btn": "+ Add account",
    "account.create_new_btn": "+ Add new account",

    "history.title": "History",

    "profile.title": "Account Information",
    "profile.email": "E-mail:",
    "profile.phone": "Phone",
    "profile.register_date": "Registration date",
    "profile.logout": "Logout",

    "profile.identification.title": "Verification",
    "profile.identification.level.title": "Current level",
    "profile.identification.upgrade.status": "Upgrade status",
    "profile.identification.upgrade_btn": "Upgrade",
    "profile.identification.refresh_status_btn": "Refresh status",
    "profile.identification.retry_upgrade_btn": "Retry identification",
    "profile.identification.profile_type": "Personal profile",

    "profile.qr.title": "This is your QR code",
    "profile.qr.share": "Share your code to receive payments",
    "profile.qr.download": "Download QR code",

    "select_currency.text": 'Выберете валюту',

    "policy.title": "Legal",

    "exchange.title": 'Exchange',
    "exchange.submit_btn": 'Exchange',
    "exchange.from": 'from',
    "exchange.to": 'to',
    "exchange.current_balance": 'Balance:',
    "exchange.no_rate": 'No rate',
    "exchange.index.success_message": 'Exchange successfully completed!',
    "exchange.not_available": 'Exchange is not available for your account',
    "exchange.rate_is_changed_modal.title": 'Exchange rate changed',
    "exchange.rate_is_changed_modal.info": 'The exchange rate was updated during the transfer',
    "exchange.status_modal.title.pending": 'Waiting for exchange',
    "exchange.status_modal.title.success": 'The exchange was successful\n',
    "exchange.status_modal.title.error": 'Failed to exchange',
    "exchange.status_modal.dont_close": "Don't close the page",
    "exchange.status_modal.try_again_later": 'Please try again later',
    "exchange.status_modal.info.summary": 'Summary',
    "exchange.status_modal.info.rate": 'Exchange rate',
    "exchange.status_modal.info.date": 'Transaction date',
    "exchange.transaction.title": "Exchange transaction",
    "exchange.transaction.from_account": "From account",
    "exchange.transaction.to_account": "To account",
    "exchange.transaction.refresh_status": "Refresh status",

    "wallet_topup.modal.title": "Wallet Top-up",
    "wallet_topup.select_account": "Select account",
    "wallet_topup.amount": "Amount",
    "wallet_topup.top_up": "Top up",
    "wallet_topup.accept_the": "I accept the",
    "wallet_topup.terms_of_use": "Terms of Use",
    "wallet_topup.success": "Success",
    "wallet_topup.error": "Top-up is temporarily unavailable. Please try again later.",
    "wallet_topup.error_empty_amount": "The 'Amount' field must be filled in",
    "wallet_topup.error_exceed_limit": "Available limit has been exceeded. To continue, you must pass verification",
    "wallet_topup.card-error": "Card payments for top-up are temporarily unavailable. Please try again later.",
    "wallet_topup.transaction_created": "Transaction created",
    "wallet_topup.redirect_message": "Continue to payment when you are ready.",
    "wallet_topup.redirect_unavailable": "Payment page is unavailable. The top-up transaction was created, but we cannot redirect you to payment.",
    "wallet_topup.continue_to_payment": "Continue to payment",
    "wallet_topup.refresh_status": "Refresh status",
    "wallet_topup.transaction_loading": "Updating transaction details...",
    "wallet_topup.methods.cbp": "SBP",
    "wallet_topup.methods.cash": "Cash top-up",
    "wallet_topup.methods.bank_card": "Bank card",

    "wallet_withdrawal.select_account": "Select account",
    "wallet_withdrawal.amount": "Amount",
    "wallet_withdrawal.card": "Card",
    "wallet_withdrawal.to-card": "Card withdrawal",
    "wallet_withdrawal.cash": "Cash withdrawal",
    "wallet_withdrawal.success_message": "Withdrawal request successfully created!",
    "wallet_withdrawal.withdrawal_btn": "Withdraw",
    "wallet_withdrawal.address": "Address",
    "wallet_withdrawal.address_invalid": "Invalid withdrawal address for selected network",
    "wallet_withdrawal.transaction_title": "Withdrawal request created",
    "wallet_withdrawal.transaction_details_title": "Transaction details",
    "wallet_withdrawal.transaction_loading": "Updating withdrawal details...",
    "wallet_withdrawal.refresh_status": "Refresh status",
    "wallet_withdrawal.transaction_error": "Withdrawal details are unavailable. Please try again later.",
    "wallet_withdrawal.transaction_wrong_type": "This transaction is not a withdrawal.",
    "wallet_withdrawal.external_id": "Withdrawal ID",
    "wallet_withdrawal.selects.network": "Network",
    "wallet_withdrawal.selects.choose_network": "Choose network",

    "select_exchange.select_account": "Select account",
    "select_exchange.from": "From",
    "select_exchange.to": "To",
    "select_exchange.search_placeholder": "Search",

    "history.statistics.title": "Account summary",
    "history.statistics.period.current_month": "Current month",
    "history.statistics.empty_current_month": "No successful operations this month",
    "history.statistics.loading": "Loading statistics...",
    "history.statistics.operations_count": "{count} ops",
    "history.category.topup": "Top-ups",
    "history.category.withdrawal": "Withdrawals",
    "history.category.exchange": "Exchanges",
    "history.category.other": "Other",

    "pay_modal.enter_pin": "Enter pin code",
    "pay_modal.enter_pin_description": "For confirmation of the transfer, enter your pin code",
    "pay_modal.waiting": "Waiting",
    "pay_modal.waiting_description": "Do not close the page",
    "pay_modal.try_again": "Try again",

    "balance_zero_state.title": "Top Up Your Account",
    "balance_zero_state.info": "Create your first currency account in the wallet and unlock new opportunities",
    "balance_zero_state.action": "Top Up Your Account",
    "kyc_zero_state.title": "Complete KYC",
    "kyc_zero_state.info": "Identity verification is required to access the service features",
    "kyc_zero_state.action": "Start KYC",
    "kyc_modal.title": "This Feature Is Unavailable",
    "kyc_modal.info": "Complete identity verification to access all app features.",
    "kyc_modal.action": "Start KYC",

    "cards_empty_list.title": "Нет созданных карт",
    "cards_empty_list.info_text": "Создайте свою первую виртуальную карту ",
    "cards_empty_list.action_label": "Создайте новую карту",

    "cards_list.add_new_card": "Add new card",

    "card_snippet.balance": "Balance",
    "card_snippet.holder": "Card holder",
    "card_snippet.creating": "Card creating",
    "card_snippet.verify_processed": "Verification process...",
    "card_snippet.verify_finished": "Verification successful!",

    "card_page.action.replenishment": "Top up",
    "card_page.action.freeze": "Freeze",
    "card_page.action.freeze.modal.title": "Freeze card",
    "card_page.action.freeze.modal.info": "While the card is frozen, all transactions will be blocked. You can unfreeze the card at any time",
    "card_page.action.unfreeze": "Unfreeze",
    "card_page.action.unfreeze.modal.title": "Unfreeze card",
    "card_page.action.unfreeze.modal.info": "After unfreezing the card, all transactions will be available again",
    "card_page.action.show": "Show",
    "card_page.action.hide": "Hide",
    "card_page.action.confirm": "Confirm",
    "card_page.action.remove": "Confirm deletion",
    "card_page.action.remove.modal.title": "Delete card",
    "card_page.action.remove.modal.info": "Deleting this card will permanently remove all remaining funds. They cannot be recovered",
    "card_page.card-details.title": "Card details",
    "card_page.card-info.title": "Card info",
    "card_page.card-info.status.active": "Active",
    "card_page.card-info.status.frozen": "Frozen",
    "card_page.card-info.card_number": "Card number",
    "card_page.card-info.expired": "Expiration date",
    "card_page.card-info.id": "ID",
    "card_page.rules.min_deposit": "Min deposit",
    "card_page.rules.max_deposit": "Max deposit",

    "card_page.replenishment.title": "Top up card",
    "card_page.replenishment.write_off_account": "Write-off account",
    "card_page.replenishment.select_account": "Select account",
    "card_page.replenishment.to_card": "To card account",
    "card_page.replenishment.conversion_rate": "Conversion rate",
    "card_page.replenishment.fee": "Transfer fee",
    "card_page.replenishment.action.replenishment_on": "Top up on",
    "card_page.replenishment.action.not_enough_balance": "Amount exceeds available balance",
    "card_page.replenishment.action.exceeds_the_limit": "Beyond limits",
    "card_page.replenishment.amount_from": "Amount from",
    "card_page.replenishment.to": "to",
    "card_page.replenishment.statuses.processing.title": "Waiting for replenishment",
    "card_page.replenishment.statuses.processing.dont_close": "Don't close the page",
    "card_page.replenishment.statuses.success.title": "The replenishment was successful!",
    "card_page.replenishment.statuses.failed.title": "Replenishment failed",
    "card_page.replenishment.statuses.failed.try_again": "Try again later",
    "card_page.replenishment.statuses.transaction_info.amount": "Amount",
    "card_page.replenishment.statuses.transaction_info.rate": "Rate",
    "card_page.replenishment.statuses.transaction_info.card": "To card account",
    "card_page.replenishment.statuses.transaction_info.date": "Date",
    "card_page.replenishment.statuses.transaction_info.id": "Transaction ID",

    "create_card_page.action_btn.title": "Create card",
    "create_card_page.selects.empty": "Empty",
    "create_card_page.selects.choose_currency": "Choose currency",
    "create_card_page.selects.selected_currency": "Selected currency",
    "create_card_page.info.title": "Activation details",
    "create_card_page.info.type": "Card type",
    "create_card_page.info.currency": "Currency",
    "create_card_page.info.price": "Activation fee",
    "create_card_page.info.min_deposit": "Min deposit",
    "create_card_page.info.max_deposit": "Max deposit",

    "create_card_page.kyc.occupation": "Occupation",
    "create_card_page.kyc.occupations.employed": "Employed",
    "create_card_page.kyc.occupations.self_employed": "Self-employed",
    "create_card_page.kyc.occupations.business_owner": "Business owner",
    "create_card_page.kyc.occupations.student": "Student",
    "create_card_page.kyc.occupations.unemployed": "Unemployed",
    "create_card_page.kyc.occupations.retired": "Retired",
    "create_card_page.kyc.occupations.freelancer": "Freelancer",
    "create_card_page.kyc.occupations.government_employee": "Government employee",
    "create_card_page.kyc.occupations.homemaker": "Homemaker",
    "create_card_page.kyc.occupations.investor": "Investor",
    "create_card_page.kyc.salary": "Annual income",
    "create_card_page.kyc.purpose": "Account purpose",
    "create_card_page.kyc.purposes.investments": "Investing",
    "create_card_page.kyc.purposes.introduction": "Exploring the App",
    "create_card_page.kyc.purposes.for_work": "Work-Related",
    "create_card_page.kyc.purposes.for_business": "Business Use",
    "create_card_page.kyc.purposes.for_storing": "Saving money",
    "create_card_page.kyc.purposes.personal_purposes": "Personal use",
    "create_card_page.kyc.volume": "Expected monthly volume",
    "create_card_page.kyc.email": "Email",
    "create_card_page.kyc.phone": "Phone number",

    "create_card_page.confirmation.title": "Enter the code from your email",
    "create_card_page.confirmation.info": "Enter the 4-digit code we sent to",

    "create_card_page.action_btn.accept": "Accept",
    "create_card_page.action_btn.send": "Send",
    "create_card_page.action_btn.next": "Next",
    "create_card_page.action_btn.send_code": "Send code",
    "create_card_page.action_btn.resend_code": "Resend code",
    "create_card_page.errors.wrong_code": "Wrong code",

    "create_card_banner.title": "Virtual card",
    "create_card_banner.subtitle": "Create your first virtual card",
    "create_card_banner.action": "Create card",

    "verification_card_page.statuses.process.title": "Verification in progress",
    "verification_card_page.statuses.process.info": "Please wait while we verify your information",
    "verification_card_page.statuses.failed.title": "Verification failed",
    "verification_card_page.statuses.failed.info": "Please review and update your information to proceed with issuing a virtual card",
    "verification_card_page.statuses.declined.title": "Application declined",
    "verification_card_page.statuses.declined.info": "We’re currently unable to issue a card for your account",
    "verification_card_page.statuses.approved.title": "Verification approved!",
    "verification_card_page.statuses.approved.info": "To issue your virtual card, please confirm the payment",
    "verification_card_page.statuses.approved.conditions.card_issuance": "Card issuance",
    "verification_card_page.statuses.approved.conditions.min_deposit": "Minimum deposit",
    "verification_card_page.statuses.approved.conditions.total_amount": "Total amount",
    "verification_card_page.statuses.approved.conditions.warning": "The amount will be deducted from your wallet",
    "verification_card_page.statuses.created.title": "Card created successfully",
    "verification_card_page.statuses.created.info": "Your virtual card has been issued and is ready to use",
    "verification_card_page.statuses.low_balance.title": "Insufficient funds",
    "verification_card_page.statuses.low_balance.info": "Please top up your wallet and try again",

    "verification_card_page.actions.close": "Close",
    "verification_card_page.actions.refresh": "Update information",
    "verification_card_page.actions.confirm": "Confirm and pay",
    "verification_card_page.actions.to_card": "View card",
    "verification_card_page.actions.to_up": "Top up wallet",

    "actives.common": "Common actives",

    "validation_fields.required": "Required field",
    "validation_fields.letters_only": "Letters only",
    "validation_fields.digits_only": "Digits only",
    "validation_fields.email": "Invalid Email",
    "validation_fields.min_8": "Enter number. Minimum 8 digits",
    "validation_fields.select_country": "Select country"
}
